import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { mapToCssModules } from './Utils'

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  dataTarget: PropTypes.string,
  dataToggle: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  toggler: PropTypes.bool,
  dropdownToggle: PropTypes.bool,
}

const defaultProps = {
  tag: 'a',
}

export const NavLink = (props) => {
  const {
    className,
    cssModule,
    tag: Tag,
    toggler,
    dataToggle,
    dataTarget,
    dropdownToggle,
    ...attributes
  } = props

  const classes = mapToCssModules(classNames(
    className,
    'nav-link',
    {
      'navbar-toggler': toggler,
      'dropdown-toggle': dropdownToggle,
    }
  ), cssModule)

  return (
    <Tag {...attributes} className={classes} data-toggle={dataToggle} data-target={dataTarget} />
  )
}

NavLink.propTypes = propTypes
NavLink.defaultProps = defaultProps
